import {API, ApiResponseBase, CustomAxiosError} from "../../../../../logics/api-config";
import {ICashTransactionsDetail} from "../../../../../utils/interfaces/Accounting/Recap/ICashTransactionsDetail";
import {useQuery, UseQueryResult} from "react-query";
import {IBookingsDetail} from "../../../../../utils/interfaces/Accounting/Recap/IBookingsDetail";


export interface ApiResponse extends ApiResponseBase {
    data: IBookingsDetail[];
}

async function doGet(ris_id: number, year: string, month: string): Promise<IBookingsDetail[]> {
    const response = await API.get(`/accounting/recap/restaurant/${ris_id}/bookings/${year}/${month}`);
    return response?.data.data;
}

const useApiGetBookingsDetail = (
    ris_id: number,
    year: string,
    month: string,
    options: any = {}
): UseQueryResult<IBookingsDetail[], CustomAxiosError> => {
    return useQuery<IBookingsDetail[], CustomAxiosError>(
        ["getBookingsDetail", ris_id, year, month],
        () => doGet(ris_id, year, month),
        { ...options }
    );
};

export default useApiGetBookingsDetail;